'use strict';

export const SERVER_STATUS_STATE = 'serverStatus';

const PING_SERVER = '@@serverStatus/PING_SERVER';
const PING_SERVER_SUCCESS = '@@serverStatus/PING_SERVER_SUCCESS';
const PING_SERVER_ERROR = '@@serverStatus/PING_SERVER_ERROR';

/**
 * Attempt to contact the server
 * @return {ReduxAction}
 */
export function pingServer() {
  return {
    type: PING_SERVER,
    payload: {},
  };
}
pingServer.TYPE = PING_SERVER;

/**
 * Successfully contacted server
 * @return {ReduxAction}
 */
export function pingServerSuccess() {
  return {
    type: PING_SERVER_SUCCESS,
    payload: {},
  };
}
pingServerSuccess.TYPE = PING_SERVER_SUCCESS;

/**
 * When issued, device could be offline, server could be down for maintenance, etc
 * @return {ReduxAction}
 */
export function pingServerError() {
  return {
    type: PING_SERVER_ERROR,
    payload: {},
  };
}
pingServerError.TYPE = PING_SERVER_ERROR;



// WEBPACK FOOTER //
// ./src/js/settings/actions/serverStatusActions.js